export default __webpack_public_path__ + "static/media/anniversarymob2.c715d04a.webp";